import { useState, useEffect } from "react";
import Navbar from "../home/components/Navbar";
import Footer from "../home/components/Footer";

export default function FAQPage() {
  const [scrolled, setScrolled] = useState(false);
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const faqs = [
    {
      category: "一般問題",
      questions: [
        {
          q: "朋睿提供哪些服務？",
          a: "朋睿是專業的資金媒合平台，為企業需求方與資金提供方建立橋樑。我們提供完整的媒合服務，包括需求評估、資料準備、媒合配對、盡職調查、合約協助以及後續追蹤服務。"
        },
        {
          q: "媒合服務需要收費嗎？",
          a: "初步諮詢是免費的。正式媒合服務會依據案件的複雜度與金額收取合理的服務費用，詳細費用會在初步評估後告知。我們採取透明收費原則，確保雙方權益。"
        },
        {
          q: "媒合流程需要多長時間？",
          a: "媒合時間因案件而異，一般來說從初步諮詢到資金到位約需3-6個月。實際時間會受到資料準備完整度、資金方審核速度等因素影響。我們會盡力加快流程，讓您能儘早取得所需資金。"
        },
        {
          q: "我的資料會保密嗎？",
          a: "絕對保密。我們非常重視客戶隱私，所有資料都會嚴格保密。在未經您同意的情況下，我們不會將您的資料透露給第三方。媒合過程中，我們也會要求雙方簽署保密協議。"
        }
      ]
    },
    {
      category: "需求方問題",
      questions: [
        {
          q: "什麼樣的企業適合使用朋睿的服務？",
          a: "各種規模與產業的企業都適合。無論您是新創企業尋求種子資金、成長型企業需要擴張資金，或是成熟企業需要營運週轉，我們都能為您找到適合的資金來源。"
        },
        {
          q: "需要準備哪些資料？",
          a: "基本資料包括：公司登記證明、近三年財務報表、營運計畫書、資金用途說明等。我們會在初步諮詢時詳細說明所需文件，並協助您準備完整的申請資料。"
        },
        {
          q: "沒有抵押品可以申請嗎？",
          a: "可以。除了傳統的擔保貸款外，我們也能媒合創投、私募基金等股權投資，或是應收帳款融資等不需要實體抵押的方案。我們會根據您的情況，推薦最適合的資金方案。"
        },
        {
          q: "媒合成功率有多高？",
          a: "成功率取決於多個因素，包括企業體質、財務狀況、產業前景等。我們會在初步評估時誠實告知媒合機會，並提供改善建議。一般而言，資料準備完整且財務健全的企業，成功率會較高。"
        }
      ]
    },
    {
      category: "資金方問題",
      questions: [
        {
          q: "朋睿如何篩選投資標的？",
          a: "我們有嚴格的篩選機制，包括：企業背景調查、財務分析、產業研究、風險評估等。只有通過多重審核的優質企業，我們才會推薦給資金方。"
        },
        {
          q: "提供哪些盡職調查服務？",
          a: "我們提供完整的盡職調查報告，包括：企業基本資料、財務狀況分析、營運模式評估、產業競爭分析、風險因子評估、投資建議等，協助資金方做出明智決策。"
        },
        {
          q: "投資後會提供追蹤服務嗎？",
          a: "會的。我們提供投資後的定期追蹤服務，包括企業營運狀況報告、重大事項通知、問題協調處理等，確保您的投資得到適當的照顧。"
        },
        {
          q: "最低投資金額是多少？",
          a: "沒有固定的最低金額限制。我們會根據您的投資偏好與企業的資金需求進行配對。無論是小額投資或大額投資，我們都能為您找到合適的機會。"
        }
      ]
    },
    {
      category: "合作相關",
      questions: [
        {
          q: "如何開始合作？",
          a: "您可以透過LINE官方帳號、電話或線上表單與我們聯繫。我們會安排專人與您進行初步諮詢，了解您的需求後提供合適的服務方案。"
        },
        {
          q: "可以親自到辦公室諮詢嗎？",
          a: "當然可以。我們於 台北內湖及台中 均設有辦公室，歡迎提前預約到訪。透過面對面諮詢，有助於我們更全面了解您的需求，並提供更具體且合適的服務方案。"
        },
        {
          q: "如果媒合不成功會怎樣？",
          a: "我們會在初步評估時誠實告知媒合機會。如果最終媒合不成功，我們會提供改善建議，並持續為您尋找其他可能的機會。部分服務費用會依約退還。"
        },
        {
          q: "可以同時尋找多個資金來源嗎？",
          a: "可以。我們建議採取多元化策略，同時評估不同的資金來源，以提高成功機會。我們會協助您比較各方案的優劣，選擇最適合的選項。"
        }
      ]
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar scrolled={scrolled} />
      
      <div className="pt-32 pb-24 bg-gradient-to-br from-black to-gray-800">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <h1 className="text-5xl font-bold text-white mb-6">常見問題</h1>
          <p className="text-xl text-white/90 max-w-3xl">
            為您整理最常見的問題與解答，如有其他疑問歡迎隨時聯繫我們
          </p>
        </div>
      </div>

      <section className="py-24 bg-white">
        <div className="max-w-4xl mx-auto px-6 lg:px-8">
          {faqs.map((category, categoryIndex) => (
            <div key={categoryIndex} className="mb-12">
              <h2 className="text-3xl font-bold text-gray-900 mb-8 flex items-center">
                <div className="w-2 h-8 bg-black rounded mr-4"></div>
                {category.category}
              </h2>
              
              <div className="space-y-4">
                {category.questions.map((faq, index) => {
                  const globalIndex = categoryIndex * 100 + index;
                  const isOpen = openIndex === globalIndex;
                  
                  return (
                    <div
                      key={index}
                      className="bg-white border-2 border-gray-200 rounded-xl overflow-hidden hover:border-black transition-colors"
                    >
                      <button
                        onClick={() => setOpenIndex(isOpen ? null : globalIndex)}
                        className="w-full px-8 py-6 flex items-center justify-between text-left hover:bg-gray-50 transition-colors"
                      >
                        <span className="text-lg font-bold text-gray-900 pr-4">{faq.q}</span>
                        <i
                          className={`${
                            isOpen ? "ri-arrow-up-s-line" : "ri-arrow-down-s-line"
                          } text-2xl text-black flex-shrink-0 transition-transform`}
                        ></i>
                      </button>
                      
                      {isOpen && (
                        <div className="px-8 pb-6">
                          <div className="pt-4 border-t border-gray-200">
                            <p className="text-gray-600 leading-relaxed">{faq.a}</p>
                          </div>
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          ))}

          <div className="mt-16 bg-gradient-to-br from-black to-gray-800 rounded-2xl p-12 text-center text-white">
            <div className="w-20 h-20 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-6">
              <i className="ri-question-answer-line text-4xl text-white"></i>
            </div>
            <h2 className="text-3xl font-bold mb-4">還有其他問題？</h2>
            <p className="text-xl mb-8 text-white/90">
              我們的專業團隊隨時準備為您解答
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href="https://line.me/R/ti/p/@678gwbht"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center px-8 py-4 bg-white text-black rounded-full font-bold text-lg hover:bg-gray-100 transition-colors whitespace-nowrap"
              >
                <i className="ri-chat-3-line text-2xl mr-3"></i>
                LINE 諮詢
              </a>
              <a
                href="/contact"
                className="inline-flex items-center justify-center px-8 py-4 bg-transparent border-2 border-white text-white rounded-full font-bold text-lg hover:bg-white/10 transition-colors whitespace-nowrap"
              >
                <i className="ri-mail-line text-2xl mr-3"></i>
                填寫表單
              </a>
            </div>
          </div>
        </div>
      </section>

      <Footer />
      
      {/* LINE 客服按鈕 */}
      <a
        href="https://line.me/R/ti/p/@678gwbht"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-28 right-6 z-40 w-14 h-14 bg-[#06C755] rounded-full flex items-center justify-center text-white shadow-lg hover:scale-110 transition-transform group"
        aria-label="LINE 即時諮詢"
      >
        <i className="ri-line-fill text-2xl"></i>
        <span className="absolute right-16 bg-gray-900 text-white px-3 py-1 rounded-lg text-sm whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          LINE 即時諮詢
        </span>
      </a>
    </div>
  );
}